import { render, staticRenderFns } from "./VRequestStep1.vue?vue&type=template&id=b8ac496e&"
import script from "./VRequestStep1.vue?vue&type=script&lang=js&"
export * from "./VRequestStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports